/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_ALL_REBATE_PROGRAMS = 'GET_ALL_REBATE_PROGRAMS';
export const SET_REQ_RECORD_MAILING_DATA = 'SET_REQ_RECORD_MAILING_DATA';
export const GET_MANUFACTURERS_BY_PQR = 'GET_MANUFACTURERS_BY_PQR';
export const RECORD_MAILING_DATE = 'RECORD_MAILING_DATE';
export const SET_DEFAULT_QTR = 'SET_DEFAULT_QTR';
export const SET_ERROR_MESSAGES_REC_M_D = 'SET_ERROR_MESSAGES_REC_M_D';
export const RESET_RECORD_MAILING_DATE_STORE_REC_M_D =
  'RESET_RECORD_MAILING_DATE_STORE_REC_M_D';
